var _g, _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconVirtualCurrency(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    y: 1,
    width: 32,
    height: 22,
    rx: 4,
    fill: "#ABC3E8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.82324,
    y: 1,
    width: 26.3529,
    height: 1.83333,
    fill: "#578FFC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.82324,
    y: 21.1665,
    width: 26.3529,
    height: 1.83333,
    fill: "#578FFC"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 20.25,
    width: 16.5,
    height: 1.88235,
    transform: "rotate(-90 0 20.25)",
    fill: "#578FFC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.1172,
    y: 20.25,
    width: 16.5,
    height: 1.88235,
    transform: "rotate(-90 30.1172 20.25)",
    fill: "#578FFC"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.9996,
    cy: 12,
    rx: 5.64706,
    ry: 5.5,
    fill: "#578FFC"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.29412,
    cy: 4.20833,
    rx: 3.29412,
    ry: 3.20833,
    fill: "#578FFC"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.58816,
    cy: 11.9998,
    rx: 1.88235,
    ry: 1.83333,
    fill: "#578FFC"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.4116,
    cy: 11.9998,
    rx: 1.88235,
    ry: 1.83333,
    fill: "#578FFC"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.29412,
    cy: 19.7918,
    rx: 3.29412,
    ry: 3.20833,
    fill: "#578FFC"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.7062,
    cy: 4.20833,
    rx: 3.29412,
    ry: 3.20833,
    fill: "#578FFC"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.7062,
    cy: 19.7918,
    rx: 3.29412,
    ry: 3.20833,
    fill: "#578FFC"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 23,
    rx: 3.5,
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8465 9.11L12.5765 13.76L11.3065 9.11H9.86652L11.9565 16H13.2065L15.2965 9.11H13.8465ZM19.2413 16.12C20.4113 16.12 21.4313 15.56 22.0513 14.69L20.9913 13.92C20.6013 14.47 20.0213 14.81 19.2813 14.81C18.0313 14.81 17.1313 13.78 17.1313 12.55C17.1313 11.32 18.0413 10.3 19.2913 10.3C20.0213 10.3 20.6013 10.64 20.9913 11.19L22.0513 10.42C21.4313 9.55 20.4113 8.99 19.2413 8.99C17.2913 8.99 15.7413 10.61 15.7413 12.55C15.7413 14.51 17.2913 16.12 19.2413 16.12Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVirtualCurrency);
export default __webpack_public_path__ + "static/media/IconVirtualCurrency.36e9f778.svg";
export { ForwardRef as ReactComponent };